import React from 'react'

const Monitoring: React.FC = () => {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">System Monitoring</h1>
        <p className="text-sm text-muted-foreground mt-1">Real-time metrics and performance monitoring</p>
      </div>
      
      <div className="bg-card border border-border rounded-md p-8 text-center">
        <p className="text-sm text-muted-foreground">Monitoring dashboard coming soon</p>
      </div>
    </div>
  )
}

export default Monitoring